module.exports = __webpack_public_path__ + "static/media/ten.a65517fd.svg";